var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_CFDI = 'api/cfdi';
const GET_SET_ORDERS_CFDI = (orderID) => `api/order/${orderID}/cfdi`;
export const createCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(GET_SET_CFDI, data, config);
        }
        catch (error) {
            console.error('Error createCFDI:', error);
            throw error;
        }
    });
};
export const createGlobalCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_CFDI}/global`, Object.assign(Object.assign({}, data), { ordersID: (_a = data.ordersID) === null || _a === void 0 ? void 0 : _a.join(',') }), config);
        }
        catch (error) {
            console.error('Error fetching create:', error);
            throw error;
        }
    });
};
export const searchGlobalByPaymentMethodCandidates = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_CFDI}/global-by-payment-method/search`, data, config);
        }
        catch (error) {
            console.error('Error searchGlobalByPaymentMethodCandidates:', error);
            throw error;
        }
    });
};
export const previewGlobalByPaymentMethodCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_CFDI}/global-by-payment-method/preview`, data, config);
        }
        catch (error) {
            console.error('Error previewGlobalByPaymentMethodCFDI:', error);
            throw error;
        }
    });
};
export const createGlobalByPaymentMethodCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_CFDI}/global-by-payment-method`, data, config);
        }
        catch (error) {
            console.error('Error createGlobalByPaymentMethodCFDI:', error);
            throw error;
        }
    });
};
